module.exports = __webpack_public_path__ + "static/media/37-iveco.b2ecca8c.jpg";